import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { CommonService } from "./../../services/common.service";
import { ToastrService } from "ngx-toastr";
import { BaseComponent } from "../../../app/pages/base.component";
import { FileuploadService } from "../../services/fileupload.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-upload-mdl',
  templateUrl: './upload-mdl.component.html',
  styleUrls: ['./upload-mdl.component.css']
})
export class UploadMdlComponent extends BaseComponent {

  @Input() approveData;
  filesToUpload: { file: File, previewUrl: string, name: string }[] = [];
  filepath: any; 
  status: any;
  getSelectedObj: any;
  INSPECTION_DATE: string = "";
  QASO_COMMENTS: string = "";
  SCDE_COMMENTS: string = "";
  users: Array<any> = [];
  @ViewChild("fileInputRef") fileInputRef: ElementRef;

  constructor(
    CommonService: CommonService, toastr: ToastrService,
    public actMdl: NgbActiveModal,
    private FileuploadService: FileuploadService
  ) {
    super(CommonService, toastr);
  }

  uploadMultiple(evnt: any = this.approveData) {
    if (this.filesToUpload.length == 0) {
     return this.toastr.info("Please Select atleast One File");
   }
   this.activeSpinner();
   const formData = new FormData();
   this.filesToUpload.forEach((file, idx) => {
     formData.append(`upload_${idx + 1}`, file.file);
   });
   formData.append("DIRECTORY_NAME", "InstituteMultiFiles"),
   formData.append("TNT_CODE", `${evnt?.TNT_CODE}`),
   formData.append("CREATED_BY", `${this.userId}`),
   formData.append("MODIFIED_BY", `${this.userId}`);
   formData.append("SEND_APPROVAL_ID", `0`);

   this.FileuploadService.upload(formData, "TenantRegistration/UploadMultipleFiles").subscribe((res: any) => {
    if(res == true) {
      this.deactivateSpinner();
      // this.closeModal();
      this.actMdl.close(res);
    }
    //  this.fileName = res.path;
    //    if (this.fileName) {
    //      this.deactivateSpinner();
    //    }
       // this.popupsCls(ctrl)
      //  document.getElementById("uploadModalCloseBtn")?.click();
      //  document.getElementById("qasoClose")?.click();
      //  this.getList();
     },
     (err) => {
       this.toastr.error(err.error.message ? err.error.message : "file not uploaded");
       this.deactivateSpinner();
     }
   );
 }

 closeModal() {
  // this.getSelectedObj = null;
  // this.users = [];
  // this.INSPECTION_DATE = "";
  // this.QASO_COMMENTS = "";

}

getList() {
  this.table = [];
  this.activeSpinner();
  this.CommonService.postCall(`TenantRegistration/GetAssignedTenantByQASO`, {
    QASO_USERID: this.userId,
  }).subscribe(
    (res: any) => {
      this.table = res;
      this.deactivateSpinner();
    },
    (e) => {
      this.deactivateSpinner();
    }
  );
}

closeUploadModal(){
  this.filepath = "";
   this.fileName = "";
   this.fileInputRef.nativeElement.value = "";
 }

 changeFile(event: any) {
  const files: FileList = event.target.files;
  const types: Array<string> = ["pdf"];
  // this.filesToUpload = [];

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const filetype = file.name.split(".").pop()?.toLowerCase();
    if (types.includes(filetype || "")) {
      const previewUrl = URL.createObjectURL(file);
      this.filesToUpload.push({ file, previewUrl, name: file.name }); // Add name property
    } else {
      this.toastr.warning("Please upload PDF file formats only");
      event.target.value = "";
      return;
    }
  }
}

removeFile(index: number) {
  // Revoke the object URL to avoid memory leaks
  URL.revokeObjectURL(this.filesToUpload[index].previewUrl);
  this.filesToUpload.splice(index, 1);
}


}
